import { render, staticRenderFns } from "./AddonsCustoms.vue?vue&type=template&id=8ac6b5e2"
import script from "./AddonsCustoms.vue?vue&type=script&lang=js"
export * from "./AddonsCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports